import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { IonContent, Platform, AlertController } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AppstorageTsService } from 'src/app/services/appstorage/appstorage.ts.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
import { LoginService } from 'src/app/services/login/login.service';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { ProgressingComponent } from '../progressing/progressing.component';
import { BiometricService } from 'src/app/services/biometric/biometric.service';
import { EventsService } from 'src/app/services/event/event.service';

@Component({
  selector: 'app-boyd-rewards-card-or-online',
  templateUrl: './boyd-rewards-card-or-online.component.html',
  styleUrls: ['./boyd-rewards-card-or-online.component.scss'],
})
export class BoydRewardsCardOrOnline implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() biometricVerificationFailed = false;

  isCustomerHasEmail: boolean = false;
  customer: CustomerModel;
  public showPassword: boolean;
  public doLoginInProgress: boolean = false;
  public email: string;
  public error: GlobalErrorHandlerService = null;
  public loginForm: FormGroup;
  public buttonDisabled: boolean = false;
	public clientapp = new FormControl('')
	public csrf = new FormControl('');
	public username = new FormControl('', [
		Validators.required,
		this.BoydCardNumberOrUsernameValidator(),
		Validators.maxLength(50),
		Validators.minLength(2)
	]);
	public password = new FormControl('');
	isPlayerLoggedInAsGuest: boolean = false;
	enabledBoydConnect: boolean;
	enabledBoydApplyCard: boolean;
	@ViewChild(ProgressingComponent) progressingUI!: ProgressingComponent;

  constructor(
    private navigator: Navigator,
    private userSessionService: UserSessionService,
    private appLinks:AppLinksService,
	private biometricService: BiometricService,
	private readonly events: EventsService,
	public alertController: AlertController,
	public platform: Platform,
    private galleryService: GalleryService,
    private loginService: LoginService,
    private globalErrorHandlerService: GlobalErrorHandlerService,
    private appStorageService: AppstorageTsService,
    private authenticationService: AuthenticationService,
	private boydRewardsService: BoydRewardsService,
    private config:ConfigService
  ) { }

  ngOnInit() {

    this.loginForm = new FormGroup({
			csrf: this.csrf,
			username: this.username,
			password: this.password,
			clientapp: this.clientapp,
		});
	this.enabledBoydApplyCard = this.config.getConfig().FEATURE_ENABLE_BOYD_APPLY_CARD ? (this.config.getConfig().FEATURE_ENABLE_BOYD_APPLY_CARD === '1' ? true : false) : true;
	this.enabledBoydConnect = this.config.getConfig().FEATURE_ENABLE_BOYD_CONNECT_CARD ? (this.config.getConfig().FEATURE_ENABLE_BOYD_CONNECT_CARD === '1' ? true : false) : true;

    this.userSessionService.getCustomer().subscribe(
      (customer) => {
        if (customer) {
          this.customer = customer;
          this.isCustomerHasEmail = !isUndefined(customer.email);
        } else {
          this.isCustomerHasEmail = false;
        }
      }, (err) => {
        console.error("getCustomer", err);
        this.isCustomerHasEmail = false;
      }
    );

	this.appStorageService.getPlayerAsGuest().then((isGuest) => {
		if (isGuest.value === 'true') return this.isPlayerLoggedInAsGuest = true;
		return this.isPlayerLoggedInAsGuest = false;
	})

  }

  goToBoydRewards(){
    return this.appLinks.openExternalPage(this.config.getConfig().BOYD_REWARDS_URL);
  }

  navigateTo(page: string,data) {
		return this.navigator.navigateTo(page,{ customModalClass: 'crown-modal',multipleModals: true},data);
	}

  private reverseTile(): any {
		return this.events.publish("events:animation:tile:reverse");
  }


  BoydCardNumberOrUsernameValidator(): ValidatorFn {
		return (control) => {
		  const value = control.value;
      const maxUsernameCharacters = 50
      if (value) {
        if (value.length <= maxUsernameCharacters) {
          return null; // valid username check
        }
        else if (/^[A-Za-z0-9]{2,11}$/.test(value)) {
          return null; // valid boyd card number
        } else {
          return { invalidInput: true }; // Invalid input
        }
      }
      return null;
		};
	}

}
